import { motion } from "framer-motion";
import { Send, ArrowUpRight } from "lucide-react";
import { TELEGRAM_URL, X_URL } from "../lib/constants";

const reveal = {
  initial: { y: 36, opacity: 0 },
  whileInView: { y: 0, opacity: 1 },
  viewport: { once: true, amount: 0.15 },
};

const XIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M18.9 1.15h3.68l-8.04 9.19L24 22.85h-7.41l-5.8-7.58-6.64 7.58H.47l8.6-9.83L0 1.15h7.59l5.24 6.93 6.07-6.93Zm-1.29 19.5h2.04L6.49 3.24H4.3l13.31 17.41Z" />
  </svg>
);

export default function Community() {
  return (
    <section id="community" data-testid="community-section" className="relative py-24 sm:py-28">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <motion.div {...reveal} className="mx-auto max-w-2xl text-center">
          <p className="text-xs font-extrabold uppercase tracking-[0.3em] text-ocean-cyan">
            Community
          </p>
          <h2 className="mt-4 font-display text-4xl font-semibold tracking-tight sm:text-5xl">
            Big waves. <span className="marker-underline">Loud community.</span>
          </h2>
          <p className="mt-3 text-base font-medium text-ocean-muted sm:text-lg">
            The pod is loud, early and always online. Pick your water.
          </p>
        </motion.div>

        <div className="mt-14 grid gap-6 md:grid-cols-2">
          <motion.a
            data-testid="social-telegram-link"
            href={TELEGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            {...reveal}
            className="btn-push sticker group flex items-center justify-between rounded-3xl bg-ocean-sky p-8 sm:p-10"
          >
            <div>
              <span className="sticker-sm inline-flex rounded-2xl bg-white p-3.5">
                <Send className="h-6 w-6 text-ocean-cyan" />
              </span>
              <h3 className="mt-5 font-display text-3xl font-semibold sm:text-4xl">
                Join the Pod
              </h3>
              <p className="mt-2 font-medium text-ocean-navy/75">
                Telegram — where the waves get loud.
              </p>
            </div>
            <ArrowUpRight className="h-10 w-10 transition-transform duration-300 group-hover:-translate-y-1 group-hover:translate-x-1" />
          </motion.a>

          <motion.a
            data-testid="social-x-link"
            href={X_URL}
            target="_blank"
            rel="noopener noreferrer"
            {...reveal}
            transition={{ ...reveal, delay: 0.1 }}
            className="btn-push sticker group flex items-center justify-between rounded-3xl bg-ocean-navy p-8 text-white sm:p-10"
          >
            <div>
              <span className="sticker-sm inline-flex rounded-2xl bg-white p-3.5">
                <XIcon className="h-6 w-6 text-ocean-navy" />
              </span>
              <h3 className="mt-5 font-display text-3xl font-semibold sm:text-4xl">
                Make Some Noise
              </h3>
              <p className="mt-2 font-medium text-white/70">
                X (Twitter) — memes first, announcements fast.
              </p>
            </div>
            <ArrowUpRight className="h-10 w-10 transition-transform duration-300 group-hover:-translate-y-1 group-hover:translate-x-1" />
          </motion.a>
        </div>
      </div>
    </section>
  );
}
